import { Box, Card, Divider, styled, Typography } from "@mui/material"
import AndroidIcon from "icons/Technologies/Android.icon";
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate } from "@tanstack/react-router";
import userInviteStore from "store/userInviteStore";

interface PredefinedInterview {
    id: string;
    name: string;
    description: string;
    difficulty: string;
}

interface AdminPredefinedInterviewProps {
    interview: PredefinedInterview;
}



const StyledCard = styled(Card)(({theme}) => ({
    borderRadius: '12px',
    background: '#FFFFFF',
    border: '1px solid var(--Light-Gray)',
    padding: '32px 32px 24px 32px',
    boxShadow: '0px 2px 4px 0px #0205111F',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-1px)',
    },
}));

const IconWrapper = styled(Box)(() => ({
    width: '64px',
    height: '64px',
}));

const StepContainer = styled(Box)(() => ({
    display: 'flex',
    gap: '4px',
}));

const StepIndicator = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'color',
    })<{ isActive?: boolean; color?: string }>(({ isActive = false, color }) => ({
    width: '32px',
    height: '2px',
    backgroundColor: isActive ? color : 'var(--Light-Gray)',
    borderRadius: '0 0 2px 2px',
}));

const DifficultyBadge = styled(Typography)(() => ({
    color: 'var(--Interviewer-Lighter-Black)',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
}));

const StyledDivider = styled(Divider)(() => ({
    height: '1px',
    width: '100%',
    margin: '0',
    borderColor: '#F0F1F3',
}));

const getIconColor = (difficulty: string) => {
    switch (difficulty.toLowerCase()) {
        case 'entry':
            return '#31C07D';
        case 'advanced':
            return '#FF9800';
        case 'professional':
            return '#FF4842';
        case 'medior':
            return '#FF9800';
        default:
            return '#34A853';
    }
};

const getStepColor = (difficulty: string) => {
    switch (difficulty.toLowerCase()) {
        case 'entry':
            return '#31C07D';
        case 'advanced':
            return '#FF9800';
        case 'professional':
            return '#FF4842';
        case 'medior':
            return '#FF9800';
        default:
            return '#34A853';
    }
};

const getStepCount = (difficulty: string) => {
    switch (difficulty.toLowerCase()) {
        case 'entry':
            return 1;
        case 'advanced':
            return 2;
        case 'professional':
            return 3;
        case 'medior':
            return 2;
        default:
            return 1;
    }
};

const AdminPredefinedInterview = ({ interview }: AdminPredefinedInterviewProps) => {

    console.log('id intertvjua', interview);


    const {userData, updateUserData} = userInviteStore();
    const navigate = useNavigate()

    const advancedGeneratorMutation = useMutation({
        mutationFn: async () => {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                'https://interviewer.runasp.net/api/interviews/advanced-generator',
                {
                    'interviewId': interview.id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        },
        onSuccess: (data) => {
            console.log('dataaa', data);
            updateUserData({
                interviewId: data.id,
                readTime: data.readTime,
                answerTime: data.answerTime,
                // deadline: '2020-11-10'
            })
            navigate({ to: '/invite-user' })
        },
        onError: (error) => {
            console.log(error);
        }
    });

    const handleInterviewClick = () => {
        console.log('dasaa');
        advancedGeneratorMutation.mutate();
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <StyledCard onClick={() => handleInterviewClick()}>
                <Box sx={{ display: 'flex'}}>
                <IconWrapper>
                    <AndroidIcon color={getIconColor(interview.difficulty)} />
                </IconWrapper>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px'}}>
                    <StepContainer>
                        {[0, 1, 2].map((step) => (
                            <StepIndicator
                                key={step}
                                isActive={step < getStepCount(interview.difficulty)}
                                color={getStepColor(interview.difficulty)}
                            />
                        ))}
                    </StepContainer>
                    <Typography variant="h2">{interview.name}</Typography>
                    <DifficultyBadge>Difficulty: {interview.difficulty}</DifficultyBadge>
                </Box>
                </Box>
                <StyledDivider />
                <Box sx={{ flex: 1 }}>
                <Typography variant="body1" color="text.secondary">
                    {interview.description}
                </Typography>
                </Box>
            </StyledCard>
        </Box>
    )
}

export default AdminPredefinedInterview